var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"#757575"}},[(_vm.layout)?_c('span',[_c('v-main',[_c('router-view')],1)],1):_c('span',[_c('nav-bar'),_c('v-main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }